import React, {useContext, useEffect, useRef, useState} from 'react';
import Datatables from "../component/Datatables";
import Modal from 'react-modal';
import {ProgressContext} from "../../context/Progress";
import SHSearch from '../component/BMCSearch';
import {Col, Container, Row, Table} from 'react-bootstrap';
import SubMenuTitle from "../component/SubMenuTitle";
import restapi from '../../helper/restAPIHelper';
import { getLoginUser, setItemWithExpireTime, USER_SESSION } from '../../helper/SecurityHelper';
import { UserContext } from '../../context/User';
import { toast } from 'react-toastify';
import errorCodeDic from '../../util/errorCodeDic';
import { useNavigate } from 'react-router-dom';


type IProps = {
};

Modal.setAppElement('#root');
const SmrtSftyCntPage = (props: IProps) => {
    const [isSaveSuccess, setIsSaveSuccess] = useState(false);
    const [srchData, setSrchData] = useState<any>();
    const searchFormRef = useRef<any>();
    const [datatable, setDatatable] = useState<any>();
    const [isRefresh, setIsRefresh] = useState<any>(null);
    const { spinner } = useContext(ProgressContext);
    const defaultUser: any = getLoginUser();
    const { user, setUser } = useContext<any>(UserContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (datatable && srchData) {
            fn_search();
        }
    }, [datatable, srchData])


    useEffect(() => {
        if (isRefresh) {
            datatable?.draw();
        }
    }, [isRefresh])


    const fn_search = (e?: any) => {
        if (e) {
            e.preventDefault()
        }
        datatable.draw();
        setIsSaveSuccess(false);
    }

    const fn_moveToSiteWeb = (siteId: number) => {
        spinner.start();
        restapi
        .changeUserSiteHeadWebStat({
        blngSiteId: siteId,
        userSeq: defaultUser.userSeq,
        })
        .then((rsltCnt: any) => {
        if (rsltCnt > 0) {
            restapi.getUserSession(defaultUser.userSeq).then((data: any) => {
            setUser(data);
            setItemWithExpireTime(USER_SESSION, data);
            navigate("/smrtSftyEqmnt");
            });
        } else {
            toast.error(errorCodeDic["003"]);
        }
        })
        .catch((error) => {
        toast.error(errorCodeDic["003"]);
        console.log("error: ", error);
        })
        .finally(() => {
        spinner.stop();
        });
    };

    return (
        <Container fluid className="bg-white px-0 bmc-txt-color-primary">
            <SubMenuTitle title={'현장별 스마트 안전장비'} parentMenu={'현장별 스마트 안전장비'}/>

            <div className="p-4 overflow-y-auto" style={{height: 'calc(100vh - 180px)'}}>
                <SHSearch datatable={datatable} formRef={searchFormRef} btnType={'p'}>
                    <Row>
                        <Col>
                            <Table className="bmc-font-SP bmc-fs-b2 my-3">
                                <tbody>
                                <tr className="border-top border-bottom align-middle">
                                    <th className="bmc-bg-th">장비 유무</th>
                                    <td>
                                        <select name={'eqmntYn'} className='form-select min-w-[100px]'>
                                            <option value=''>전체</option>
                                            <option value='Y'>보유 현장</option>
                                        </select>
                                    </td>
                                    <th className="bmc-bg-th">검색어</th>
                                    <td className="w-[40%]">
                                        <input type={'text'} name={'srchTxt'} className='form-control'/>
                                    </td>
                                </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </SHSearch>


                <div className={'ge-result'}>
                    <Datatables
                        dataUrl={'/admin/api/smrtSftyEqmnt/retrieveSmrtSftyEqmntDataCnt'}
                        parameterFormRef={searchFormRef}
                        columns={[
                            {data: "siteName", title: "현장명"},
                            {data: "siteAddress", title: "주소"},
                            {data: "cnt", title: "총개수"},
                            {data: "cnt001", title: "계측기"},
                            {data: "cnt002", title: "스마트 센스장비"},
                            {data: "cnt003", title: "스마트 웨어러블"},
                            {data: "cnt004", title: "기타"},
                        ]}
                        checked={false}
                        index={true}

                        onLoad={(dt: any) => {
                            setDatatable(dt)
                        }}
                        onClick={(data) => {
                            fn_moveToSiteWeb(data.siteId);
                        }
                        }
                    />
                </div>
            </div>
        </Container>


    );
};

export default SmrtSftyCntPage;
